import { render, staticRenderFns } from "./daftar_tunggakan.vue?vue&type=template&id=077ac13a&"
import script from "./daftar_tunggakan.vue?vue&type=script&lang=js&"
export * from "./daftar_tunggakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports